import { memo } from 'react';

import { Select } from 'antd';

import AppModal from '../../../components/AppModal';

const ChooseGroupsModal = ({ isOpen, onCancel, handleGroupsChange, onSave, values = [], options = [] }) => {
  return (
    <AppModal isOpen={isOpen} confirmButtonText="Save" title="Groups" handleCancel={onCancel} handleConfirm={onSave}>
      <div className="py-4">
        <Select
          className="w-full"
          mode="multiple"
          optionFilterProp="label"
          options={options}
          showSearch={true}
          value={values}
          onChange={handleGroupsChange}
        />
      </div>
    </AppModal>
  );
};

export default memo(ChooseGroupsModal);
